import { ColDef } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import ModalFooter from '../common/ModalFooter';
import ClientSideAgGrid from '../common/customAgGrid/ClientSideAgGrid';
import Modal from '../common/Modal';
import { TruncatedCellText } from '../common/styled/TruncatedCellText';

const CheckIssuesModal = ({
  open,
  onClose,
  onUploadUpdatedFile,
  onBack,
  issuesRows = [],
}: {
  open: boolean;
  onClose: () => void;
  onUploadUpdatedFile: () => void;
  onBack: () => void;
  issuesRows?: Array<{ rowNo: number | string; column: string; error: string }>;
}) => {
  const { t } = useTranslation();
  const columns: ColDef[] = [
    {
      field: 'rowNo',
      headerName: t('priceList.rowNo'),
      width: 110,
      maxWidth: 110,
      filter: false,
      sortable: false,
    },
    {
      field: 'column',
      headerName: t('priceList.column'),
      width: 150,
      maxWidth: 300,
      filter: false,
      sortable: false,
    },
    {
      field: 'error',
      headerName: t('priceList.error'),
      width: 300,
      filter: false,
      sortable: false,
      cellRenderer: (params: any) => (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <TruncatedCellText>{params?.value}</TruncatedCellText>
        </Box>
      ),
    },
  ];
  const issuesData: any[] = issuesRows;
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('priceList.checkIssuesTitle')}
      size="lg"
      isPriceListModal={true}
      footer={
        <ModalFooter
          onCancel={onBack}
          onSubmit={onUploadUpdatedFile}
          cancelText={t('buttons.back')}
          submitText={t('priceList.uploadUpdatedFile')}
        />
      }
    >
      <Box sx={{ height: '400px' }}>
        <ClientSideAgGrid
          columnDefs={columns}
          rowData={issuesData}
          loading={false}
          className="check-issues-grid"
          isInModal={true}
          infiniteRows={true}
        />
      </Box>
    </Modal>
  );
};

export default CheckIssuesModal;
